export default __webpack_public_path__ + "static/Sun Protection Policy-29faf93d18c957a14bf3969914e174f8.pdf";